import React from 'react';
import {
  Tab as MuiTab,
  Tabs as MuiTabs,
  TabProps,
  TabsProps,
} from '@mui/material';
import classNames from 'classnames';
import styles from '../../../stylesheets/management_site/tabs.module.scss';
import ButtonGlimmer from './ButtonGlimmer';

export const Tabs = ({ className, ...props }: TabsProps) => {
  return <MuiTabs className={classNames(styles.tabs, className)} {...props} />;
};

export const Tab = ({ className, ...props }: TabProps) => {
  return <MuiTab className={classNames(styles.tab, className)} {...props} />;
};

export const TabsGlimmer = ({
  className,
  numTabs,
}: {
  className?: string;
  numTabs: number;
}) => {
  return (
    <div className={classNames(styles.tabsGlimmer, className)}>
      {Array.from({ length: numTabs }).map((_, index) => (
        <ButtonGlimmer key={index} />
      ))}
    </div>
  );
};
